export const GameStageStatusTypes = {
    ALL: {
        title: "همه",
        id: "All"
    },
    ACTIVE: {
        title: "فعال",
        id: "ACTIVE"
    },
    INACTIVE: {
        title: "غیر فعال",
        id: "INACTIVE"
    },
    DRAFT: {
        title: "پیش نویس",
        id: "DRAFT"
    },
    ARCHIVED: {
        title: "بایگانی شده",
        id: "ARCHIVED"
    },

}

export function getGameStageStatus(status) {

    switch (status) {

        case GameStageStatusTypes.ACTIVE.id: {
            return GameStageStatusTypes.ACTIVE.title
        }
        case GameStageStatusTypes.INACTIVE.id: {
            return GameStageStatusTypes.INACTIVE.title
        }
        case GameStageStatusTypes.DRAFT.id: {
            return GameStageStatusTypes.DRAFT.title
        }
        case GameStageStatusTypes.ARCHIVED.id: {
            return GameStageStatusTypes.ARCHIVED.title
        }

    }

}